module.exports = __webpack_public_path__ + "static/image/history/pc/202305.ver2_0_2.jpg?dacd10c0";